import { render, staticRenderFns } from "./XSDisplayCard.vue?vue&type=template&id=3dbfe35c&scoped=true&"
import script from "./XSDisplayCard.vue?vue&type=script&lang=js&"
export * from "./XSDisplayCard.vue?vue&type=script&lang=js&"
import style0 from "./XSDisplayCard.vue?vue&type=style&index=0&id=3dbfe35c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dbfe35c",
  null
  
)

export default component.exports